/** @jsx jsx */
import { Checkbox as BaseCheckbox, jsx, Label } from '@front10/base-elements';
import { ComponentPropsWithoutRef } from 'react';

export function Checkbox({
  label,
  ...props
}: ComponentPropsWithoutRef<typeof BaseCheckbox> & { label: string }) {
  return (
    <Label
      variant="text.fontSize5"
      sx={{
        color: 'text',
        width: 'unset',
        display: 'inline-flex',
        alignItems: 'center',
        'input:focus ~ svg': { boxShadow: 'focus' }
      }}
    >
      <BaseCheckbox {...props} />
      {label}
    </Label>
  );
}
